var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 12C15.8125 12 16.5 11.3438 16.5 10.5V1.5C16.5 0.6875 15.8125 0 15 0H2C1.15625 0 0.5 0.6875 0.5 1.5V10.5C0.5 11.3438 1.15625 12 2 12H15ZM4 1.75C4.9375 1.75 5.75 2.5625 5.75 3.5C5.75 4.46875 4.9375 5.25 4 5.25C3.03125 5.25 2.25 4.46875 2.25 3.5C2.25 2.5625 3.03125 1.75 4 1.75ZM2.5 10V8.5L4.71875 6.28125C4.875 6.125 5.09375 6.125 5.25 6.28125L7 8L11.2188 3.78125C11.375 3.625 11.5938 3.625 11.75 3.78125L14.5 6.5V10H2.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcImg);
export default __webpack_public_path__ + "static/media/ic-img.2c30b4a63db563215933e7186e127c3f.svg";
export { ForwardRef as ReactComponent };